/* istanbul ignore file */
import { isBrowser } from '@noths/polaris-client-feature-capabilities';
import histore from 'histore';

export const pageHistory = isBrowser() ? histore() : null;
